import React from "react"

import { VALID_FILE_TYPES } from "@productlane/api/src/lib/files"

export interface FileUploadInputProps {
	id: string
	onFilesAdded: (files: { file: File; id: string; url: string }[]) => void
	accept?: string
}

const DEFAULT_ACCEPT = VALID_FILE_TYPES.map((type) => `.${type}`).join(",")

export const FileUploadInput: React.FC<FileUploadInputProps> = ({
	id,
	onFilesAdded,
	accept = DEFAULT_ACCEPT,
}) => {
	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files) {
			const newFiles = Array.from(e.target.files).map((file) => {
				const id = Math.random().toString(36).substring(7)
				return {
					file,
					id,
					url: URL.createObjectURL(file),
				}
			})
			onFilesAdded(newFiles)
		}
		e.target.value = "" // Reset the input value to allow re-uploading the same file
	}

	return (
		<input
			id={`${id}-file-upload`}
			type="file"
			name="files"
			accept={accept}
			multiple
			className="hidden"
			onChange={handleFileChange}
		/>
	)
}
